import React, {ReactNode} from "react";
import {Trans} from "react-i18next";


export const trans = (key: string, def: ReactNode) => {
    return <Trans i18nKey={key}>{def}</Trans>
}